import store from './store'
export function handleButtonClick(action, ...params) {

    const subStatus = store.getters['user/subscriptionStatus'];
    const isSubscribed = subStatus === 'active' || subStatus === 'trialing';

    //if user is subscribed then allow all permission according to plan       
    if (isSubscribed && typeof action === "function" ) {
        action(...params);
        return;
    }

    //if user is not loggedin restrict the features
    if (store?.getters?.getUserId == null) {
        store.commit('SET_RESTRICT_POPUP', true);
        return;
    }

    //allow only 3 time to use tool if user is not subscribed yet
    const category = params[1];
    const toolId = params[2];

    if (category === "drawing") {
        // savedDrawingData contains the initial data fetched from the DB for all symbols
        const savedDrawingData = store.getters.savedDrawingData || [];
        const multiDrawingData = store.getters.multiDrawingData || [];
        
        const usedToolsOnAccount = new Set();
        
        // 1. Check all tools saved in the DB (for all symbols)
        savedDrawingData.forEach(item => {
            for (let dataRef in item.drawingData) {
                try {
                    const drawingObj = JSON.parse(item.drawingData[dataRef]);
                    if (drawingObj.type) usedToolsOnAccount.add(drawingObj.type.toLowerCase());
                } catch(e) {}
            }
        });
        // 2. Also check current unsaved drawings on open tabs
        multiDrawingData.forEach(tabDrawings => {
            for (let dataRef in tabDrawings) {
                try {
                    const drawingObj = JSON.parse(tabDrawings[dataRef]);
                    if (drawingObj.type) usedToolsOnAccount.add(drawingObj.type.toLowerCase());
                } catch(e) {}
            }
        });
        const currentToolId = toolId.toLowerCase();
        // 3. Block only if they try to use a 4th unique tool type across their whole account
        if (usedToolsOnAccount.size >= 3 && !usedToolsOnAccount.has(currentToolId)) {
            store.commit('SET_TOOL_RESTRICT_POPUP', true);
            return;
        } else {
            action(params[0]);
        }
    }
     else if (category === "indicator") {
        const usedIndicators = store.getters['user/userIndicators'] || [];
        const selectedIndicators = params[2] || [];
       // console.log("selectedIndicators:",selectedIndicators)
        let uniqueCount = usedIndicators.length;
        let newIndicators = [];
        
        for (let ind of selectedIndicators) {
            if (!usedIndicators.includes(ind.name)) {
                uniqueCount++;
                newIndicators.push(ind.name);
            }
        }
        
        if (uniqueCount > 3) {
            store.commit('SET_TOOL_RESTRICT_POPUP', true);
            return;
        } else {
            newIndicators.forEach(name => {
                store.commit('user/AddUsedIndicator', name);
            });
            action(params[0]);
        }
    }
    //restrict user to access other feature
    else {
        store.commit('SET_RESTRICT_POPUP', true);
        return;
    }
}